export default "__VITE_ASSET__CeKjuS2P__"